<template>
  <div class="jf-hero">
    <div class="jf-hero__overlay"></div>
    <div class="container jf-hero__content">
      <div class="row">
        <div class="col-md-10 offset-md-1 text-center">
          <h1 class="jf-hero__title">{{ event.title }}</h1>
          <p class="jf-hero__subtitle">{{ event.subtitle }}</p>
          <div class="jf-hero__details">
            <span><i class="icon-feather-calendar"></i> {{ event.date }}</span>
            <span><i class="icon-feather-clock"></i> {{ event.time }}</span>
            <span><i class="icon-feather-map-pin"></i> {{ event.venue }}</span>
          </div>
          <button class="button ripple-effect big jf-hero__cta" @click="scrollToRegister">
            Register Now <i class="icon-feather-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true }
  },
  methods: {
    scrollToRegister() {
      var el = document.getElementById('register');
      if (!el) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var targetY = el.getBoundingClientRect().top + scrollTop;
      $('html, body').stop().animate({ scrollTop: targetY }, 600);
    }
  }
};
</script>

<style lang="scss" scoped>
.jf-hero {
  position: relative;
  min-height: 520px;
  display: flex;
  align-items: center;
  background: url('/images/job-fair/hero-bg.jpg') center/cover no-repeat;
  padding: 80px 0 60px;

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(26, 42, 108, 0.55) 0%, rgba(42, 65, 232, 0.45) 50%, rgba(74, 108, 247, 0.4) 100%);
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 2;
  }

  &__title {
    color: #fff;
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 15px;
    letter-spacing: -0.5px;
  }

  &__subtitle {
    color: rgba(255, 255, 255, 0.9);
    font-size: 20px;
    margin-bottom: 30px;
  }

  &__details {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 25px;
    margin-bottom: 35px;

    span {
      color: rgba(255, 255, 255, 0.95);
      font-size: 16px;

      i {
        margin-right: 6px;
      }
    }
  }

  &__cta {
    background: #fff !important;
    color: #2a41e8 !important;
    font-weight: 600;
    padding: 14px 40px !important;
    font-size: 18px !important;
    border-radius: 4px;

    &:hover {
      background: #f0f0f0 !important;
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    }

    i {
      margin-left: 8px;
    }
  }

}

@media (max-width: 768px) {
  .jf-hero {
    min-height: 420px;
    padding: 60px 0 40px;

    &__title {
      font-size: 32px;
    }

    &__subtitle {
      font-size: 16px;
    }

    &__details {
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>
